import translationFR from "@/assets/locales/fr/translations.json";
import translationEN from "@/assets/locales/en/translations.json";
import translationJA from "@/assets/locales/ja/translations.json";

export enum Locales {
  FR = "FR",
  EN = "EN",
  JA = "JA",
}

export const LocaleTranslations = {
  [Locales.FR]: {
    translation: translationFR,
  },
  [Locales.EN]: {
    translation: translationEN,
  },
  [Locales.JA]: {
    translation: translationJA,
  },
};

export const isLanguageSupported = (language: string): boolean => {
  return Object.values(Locales).includes(language.toUpperCase() as Locales);
};
